import { useOverflowObserver } from '@/shared/hooks/useOverflowObserver';
import Tooltip from '@/shared/ui/primitives/Tooltip';

const EllipsisWithTooltip = ({ text }: { text: string }) => {
  const [ref, isOverflowed] = useOverflowObserver([text]);

  return (
    <div style={{ width: '100%' }}>
      <Tooltip
        title={isOverflowed ? text : ''}
        variant='secondary'
      >
        <span
          ref={ref}
          style={{
            display: 'inline-block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            marginTop: '5px'
          }}
        >
          {text}
        </span>
      </Tooltip>
    </div>
  );
};

export default EllipsisWithTooltip;
